import { render, staticRenderFns } from "./SearchSidebar.vue?vue&type=template&id=5a528a17"
import script from "./SearchSidebar.vue?vue&type=script&lang=js"
export * from "./SearchSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports